import { Component, OnInit ,ViewChild} from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../_services/alert.service";
import { environment } from "../../../../environments/environment";
import { ApiHttpService } from "../../../_services/api-http.service";
import {Router, Routes} from "@angular/router";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
import { GrievanceEditComponent } from './grievance-edit/grievance-edit.component';
const { API_URL } = environment;
@Component({
  selector: 'app-grievance-report',
  templateUrl: './grievance-report.component.html',
  styleUrls: ['./grievance-report.component.scss'],
  providers: [DatePipe]
})
export class GrievanceReportComponent implements OnInit {
  currentDate:any=new Date();
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];
  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;
  // public rowData: any[];
  public rowData: any[] = [
    // Add more rows here as needed...
  ];
  public deleterowData: any[] = [
    // Add more rows here as needed...
  ];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'grsTittle', tooltipField: 'sp_id', headerName: 'Title'},
    { field: 'createdBy', tooltipField: 'sp_id', headerName: 'Email ID'},
    { field: "grsId", tooltipField: 'sp_id', headerName: 'GRS ID' },
    { field: "status", tooltipField: 'sp_id', headerName: 'Status' },
    { field: 'createdDate', tooltipField: 'sp_id', headerName: 'Created On'},
    { field: "updatedAt", tooltipField: 'sp_id', headerName: 'Updated On' },
  ];
  flagMerchnat:boolean;
  myDate = new Date();
  merchantStatusdata: any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 0;
  collectionSize: number = 0;
  merchantdis: boolean = true;
  filedis: boolean = true;
  selectedFile:any;
  public searchFromDate: any;
  public searchToDate: any;
  Status:any
  searchdate:any
  Searchstatus:any
  searchdateto:any
  active:boolean;
  inactive:boolean;
  constructor(private datePipe: DatePipe,  private router: Router,private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService, ) {
    this.merchantStatusdata  = [
      {
        "FieldValue": "ALL",
        "FieldText": "ALL"
      },
      {
        "FieldValue": "NEW",
        "FieldText": "NEW"
      },
      {
        "FieldValue": "REOPENED",
        "FieldText": "REOPENED"
      },
      {
        "FieldValue": "INPROGRESS",
        "FieldText": "INPROGRESS"
      },
      {
        "FieldValue": "CLOSED",
        "FieldText": "CLOSED"
      }]
   }
  ngOnInit(): void {
    this.active=false;
    this.inactive=true;
  }
  onSearchmerchant(){
    this.active=false;
    this.inactive=true;
debugger
   this. flagMerchnat=true
  this. reloadonGridReady();
  }
  onSearchCustomer(){
    this.active=true;
    this.inactive=false;
    this. flagMerchnat=false
    this. reloadonGridReady();
  }
  changeEndDate()
  {
    this.currentDate=this.searchToDate
  }
  ondataSearch(event:any){
    if(event){
    }else{
     this.reloadonGridReady()
    }
  }
  changeDate(){
    this.currentDate=this.searchFromDate
  }
  onSearchBtnClick(event:any):void{
    // searchdate:any
    // Searchstatus:any
    // searchdateto:any
    if(this.searchToDate&& this.searchFromDate){
    debugger
    if(this.Status){
this.Searchstatus=   this.Status
    }else{
      this.Searchstatus=  "All"
    }
    this.Status
    this.searchToDate
    this.searchFromDate
      this.merchantdis=true;
      debugger
      this.apiHttpService
      .get(
        `https://uat.pay10.com/crmws/GRS/findAllGRS/All/${this.Searchstatus}/${this.searchFromDate}/${this.searchToDate}`
      )
      .subscribe((data) => {
        let count=0;
        if(this.flagMerchnat){
        this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
          if(d.payId=="N/A"){
            data.grs.splice(count, 1);
          }
        count=  count+1;
       })}else
       {
        this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
          if(d.payId!="N/A"){
            data.grs.splice(count, 1);
          }
          count=  count+1;
       })
       }
        this.collectionSize = data.grs.length        ;
        this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
           return {
            ...d,
          }
        })
      });
    }else{
      this.merchantdis=false
    }
  }
  onPageSizeChanges($event: Event) {
  }
  tableSelectedColumn: ColDef[] = [...this.columnDefs];
  reloadonGridReady(){
    let createdata = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    const myDatedata = new Date();
    myDatedata.setDate(myDatedata.getDate() - 7);
    const  dateString = this.datePipe.transform(myDatedata, 'yyyy-MM-dd');
    this.filedis=true;
      this.merchantdis=true;
      debugger
      return this.apiHttpService
      .get(
        `https://uat.pay10.com/crmws/GRS/findAllGRS/All/All/${dateString}/${createdata}`
      )
      .subscribe((data) => {
        let count=0;
        if(this.flagMerchnat){
        this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
          if(d.payId=="N/A"){
            data.grs.splice(count, 1);
          }
        count=  count+1;
       })}else
       {
        this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
          if(d.payId!="N/A"){
            data.grs.splice(count, 1);
          }
          count=  count+1;
       })
       }
       this.collectionSize = data.grs.length        ;
        this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
          return {
           ...d,
         }
       })
        this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
           return {
            ...d,
          }
        })
      });
  }
  onGridReady(datra:any){
    debugger
  let createdata = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
  const myDatedata = new Date();
    myDatedata.setDate(myDatedata.getDate() - 7);
    const  dateString = this.datePipe.transform(myDatedata, 'yyyy-MM-dd');
    this.filedis=true;
      this.merchantdis=true;
      debugger
      return this.apiHttpService
      .get(
        `https://uat.pay10.com/crmws/GRS/findAllGRS/All/All/${dateString}/${createdata}`
      )
      .subscribe((data) => {
let count=0;
        this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
          if(d.payId=="N/A"){
            data.grs.splice(count, 1);
          }
        count=  count+1;
       })
        this.collectionSize = data.grs.length        ;
        this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
           return {
            ...d,
          }
        })
      });
  }
  onFilterModified(param: FilterModifiedEvent | any) {
    debugger
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }
  onPaginationChange(param: PaginationChangedEvent | any) {
    if(this.searchToDate&& this.searchFromDate){
    }else{
  // this.searchToDate= this.datepipe.transform((new Date), 'MM/dd/yyyy h:mm:ss');
   //this.searchFromDate=Date.now()-7
    }
      debugger
      if(this.Status){
  this.Searchstatus=   this.Status
      }else{
        this.Searchstatus=  "All"
      }
      if( this.searchToDate&&  this.searchFromDate){
      }else
      {
        this.searchToDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
        const myDatedata = new Date();
        myDatedata.setDate(myDatedata.getDate() - 7);
        // The following returns the formatted date.
        this.searchFromDate = this.datePipe.transform(myDatedata, 'yyyy-MM-dd');
      }
        this.apiHttpService
        .get(
          // `https://uat.pay10.com/crmws/GRS/findAllGRS/All/${this.Searchstatus}/${this.searchFromDate}/${this.searchToDate}`
          `https://uat.pay10.com/crmws/GRS/findAllGRS/All/${this.Searchstatus}/${this.searchFromDate}/${this.searchToDate}`
          )
        .subscribe((data) => {
          let count=0;
          if(this.flagMerchnat){
          this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
            if(d.payId=="N/A"){
              data.grs.splice(count, 1);
            }
          count=  count+1;
         })}else
         {
          this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
            if(d.payId!="N/A"){
              data.grs.splice(count, 1);
            }
            count=  count+1;
         })
         }
          this.collectionSize = data.grs.length ;
          this.pageSize
       let currentpagedata=   this.currentPage-1;
          this.deleterowData=this.rowData = (data.grs?.data|| Array.isArray(data.grs) ? data.grs : []).map((d: any) => {
            return {
             ...d,
           }
         })
         this.deleterowData.splice(0,currentpagedata*this.pageSize)
          this.rowData =  this.deleterowData
        });
    this.gridApi.paginationGoToPage(param - 1)
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }
  async onRowDoubleClicked(param: RowClickedEvent | any) {
    let data=param.data
     // window.open("/#/grievanceEdit?data="+data.grsId)
      this.router.navigateByUrl("/grievanceEdit?data="+data.grsId);
};
}